export default __webpack_public_path__ + "static/media/timer-end.e0ece14f.mp3";